import * as z from 'zod';

import { LosId } from '../../BrandedIds';
import { Checkbox, dateIsOnFirstOfMonth, DateString, NonNegativeFloat } from '../fields';
import { FhaAdpCodeEnum, InvestorNameEnum } from './CreateLoanRow';

export const UpdateIdsAndRemittanceDataRow = z.object({
  loanId: LosId,
  effectiveDate: DateString.and(dateIsOnFirstOfMonth).optional(),
  soldDate: DateString.optional(),

  // External ids
  poolId: z.string().optional(),
  previousServicerId: z.string().optional(),
  originatorId: z.string().optional(),
  previousLoanOwner: z.string().nullable().optional(),
  capitalPartnerId: z.string().optional(),
  fullId: z.string().optional(),
  otherId1: z.string().optional(),
  otherId2: z.string().optional(),
  otherId3: z.string().optional(),
  ownerId: z
    .string()
    .optional()
    .describe(
      'Use this field when the owner is NOT Fannie Mae, Freddie Mac, or Ginnie Mae. To declare those owners, use `investorName`.',
    ),

  // Investor reporting fields
  investorName: InvestorNameEnum.optional().describe(
    'Use this field when the investor is Fannie Mae, Freddie Mac, or Ginnie Mae. For any other investor, use `ownerId`.',
  ),
  investorLoanId: z.string().optional(),
  fhaCaseNumber: z.string().optional(),
  fhaAdpCode: FhaAdpCodeEnum.optional(),

  // Investor remittance fields
  investorRemittanceRate: NonNegativeFloat.optional(),
  investor2RemittanceRate: NonNegativeFloat.optional(),
  servicerRemittanceRate: NonNegativeFloat.optional(),
  investorOwnershipPercent: NonNegativeFloat.optional(),
  investor2OwnershipPercent: NonNegativeFloat.optional(),
  guaranteeFeeRate: NonNegativeFloat.optional(),

  removeConcurrentAndFutureData: Checkbox.optional(),
});
export type UpdateIdsAndRemittanceDataRow = z.infer<typeof UpdateIdsAndRemittanceDataRow>;

export const UPDATE_IDS_AND_REMITTANCE_DATA_REQUIRED_FIELDS = Object.keys(UpdateIdsAndRemittanceDataRow.shape).filter(
  (key) => !UpdateIdsAndRemittanceDataRow.shape[key as keyof typeof UpdateIdsAndRemittanceDataRow.shape].isOptional(),
);
